import React, { createContext, useEffect, useState, useContext } from "react";
import { v4 as uuidv4 } from "uuid";
import { CarrierContext } from "../contexts/CarrierContext";
import { getAPIData } from "../services/guestService";
import { LogContext } from "./LogContext";

export const PaymentNachaContext = createContext();

export const PaymentNachaProvider = ({ children }) => {
  const [nachaContent, setNachaContent] = useState("");
  const [nachaMainHeading, setNachaMainHeading] = useState("");
  const [nachaTermsConditions, setNachaTermsConditions] = useState("");
  const [nachaESign, setNachaESign] = useState("");
  const [nachaContentSubHeading, setNachaContentSubHeading] = useState("");
  const [nachaCarrierName, setNachaCarrierName] = useState("@CARRIER_NAME");
  const [nachaBillingFreq, setNachaBillingFreq] = useState("@BILL_FREQUENCY");
  const carrierContxt = useContext(CarrierContext);
  const { Log } = useContext(LogContext);

  const getNachaContent = (payment_method, binder_type) => {
    let nacha_content = "";
    const guid = uuidv4();
    const urlCarrier = carrierContxt.hasOwnProperty("carrier")
      ? carrierContxt.carrier
      : null;
    const carr_code = "REACT_APP_" + urlCarrier.toUpperCase();
    const carr_code_val = process.env[carr_code];
    const nacha_client_id = "REACT_APP_NACHA_API_CLIENT_ID_" + carr_code_val;
    const nacha_client_secret =
      "REACT_APP_NACHA_API_CLIENT_SECRET_" + carr_code_val;
    let response = "";
    const headers = {
      "X-Hps-Trace-Id": guid,
      "X-Hps-Ts": Date.now(),
      "X-Hps-Carrier-Code": process.env[carr_code],
      "X-Hps-Sender-Id": "GUEST PAYMENT PORTAL",
      "X-Hps-SiteCd": process.env[carr_code] + "GPT",
      "X-Hps-Client-Id": process.env[nacha_client_id],
      "X-Hps-Secret-Id": process.env[nacha_client_secret],
      "X-Hps-Db-Region": process.env.REACT_APP_REGION,
      "X-Hps-Lang-Code": sessionStorage.getItem("langSel"),
    };
    if (payment_method && binder_type && sessionStorage.getItem("langSel")) {
      getAPIData(process.env.REACT_APP_NACHA_API_URL, "", headers)
        .then((result) => {
          if (result) {
            if (result.status && result.data && result.status === 200) {
              response = result.data;
              if (!response.error) {
                if (response.status_code === "HPS200") {
                  const nachaContentData =
                    response?.page_content &&
                    response.page_content[sessionStorage.getItem("langSel")]
                      ? response.page_content[sessionStorage.getItem("langSel")]
                      : "";
                  const nacha_content_key =
                    "nacha_content_for_" + payment_method + "_" + binder_type;

                  nacha_content =
                    nachaContentData?.nacha_content?.[nacha_content_key] || "";
                  setNachaContent(nacha_content);
                  const nacha_main_heading =
                    nachaContentData?.nacha_content?.nacha_content_main_heading;
                  setNachaMainHeading(nacha_main_heading);
                  const nacha_content_terms_conditions =
                    nachaContentData?.nacha_content
                      ?.nacha_content_terms_conditions;
                  setNachaTermsConditions(nacha_content_terms_conditions);
                  const nacha_content_e_signature =
                    nachaContentData?.nacha_content?.nacha_content_e_signature;
                  setNachaESign(nacha_content_e_signature);
                  const nacha_content_carrier_name =
                    nachaContentData?.nacha_content?.nacha_content_carrier_name;
                  setNachaCarrierName(nacha_content_carrier_name);
                  const nacha_content_sub_heading =
                    nachaContentData?.nacha_content?.nacha_content_sub_heading;
                  setNachaContentSubHeading(nacha_content_sub_heading);
                  const nacha_billing_freq =
                    nachaContentData?.nacha_content
                      ?.nacha_content_billing_frequency;
                  setNachaBillingFreq(nacha_billing_freq);
                } else {
                  Log(
                    "Payment Nacha API",
                    "API",
                    "",
                    "API failure",
                    "ERROR",
                    headers,
                    result,
                    process.env.REACT_APP_NACHA_API_URL,
                    "F"
                  );
                }
              } else {
                Log(
                  "Payment Nacha API",
                  "API",
                  "",
                  "API failure",
                  "ERROR",
                  headers,
                  result,
                  process.env.REACT_APP_NACHA_API_URL,
                  "F"
                );
              }
            } else {
              const errorTxt = "Payment Nacha Error: " + result.status;
              var resultErr = "";
              if (result.error) {
                resultErr = result.error;
              }
              if (result.errors && result.errors.text) {
                resultErr += result.errors.text;
              }
              Log(
                "Payment Nacha API",
                "API",
                "",
                "API failure: " +
                  errorTxt +
                  "Payment Nacha Error: Technical Error: " +
                  resultErr,
                "ERROR",
                headers,
                result,
                process.env.REACT_APP_NACHA_API_URL,
                "F"
              );
            }
          } else {
            Log(
              "Payment Nacha API",
              "API",
              "",
              "API failure",
              "ERROR",
              headers,
              result,
              process.env.REACT_APP_NACHA_API_URL,
              "F"
            );
          }
        })
        .catch((error) => {
          let errMsg = "";
          if (error.response) {
            // The request was made and the server responded with a status code

            errMsg =
              "Payment Nacha Error: Technical Error: " +
              " : " +
              error.response.status +
              " : " +
              error.response.statusText;
          } else if (error.request) {
            // The request was made but no response was received
            errMsg =
              "Payment Nacha Error: Technical Error: " +
              error.request.status +
              " : " +
              error.response.statusText;
          } else {
            // Something happened in setting up the request that triggered an Error
            errMsg = error.message ? error.message : "";
          }
          Log(
            "Payment Nacha API",
            "API",
            "",
            "Got exception: API failure: " + errMsg,
            "ERROR",
            headers,
            error,
            process.env.REACT_APP_NACHA_API_URL,
            "F"
          );
        })
        .finally(() => {
          // return nacha_content;
        });
    }
  };
  /* Toast */
  return (
    <PaymentNachaContext.Provider
      value={{
        getNachaContent,
        nachaContent,
        setNachaContent,
        nachaMainHeading,
        nachaTermsConditions,
        nachaESign,
        nachaCarrierName,
        nachaBillingFreq,
        nachaContentSubHeading,
      }}
    >
      {children}
    </PaymentNachaContext.Provider>
  );
};
